const messageInvalid = 'Valor do campo não é válido.';
const messageEmailInvalid = 'E-mail Inválido!';

export const required = v => !!v || 'Este campo é obrigatório';

export const email = v => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return pattern.test(v) || messageEmailInvalid;
};

export const cpf = v => {
  if (v === null || v === undefined || v === '') return false;

  v = v.replace(/\-/g, '').replace(/\./g, '');

  if (!/^[0-9]+$/.test(v)) return messageInvalid;

  if (
    v.length != 11 ||
    v == '191' ||
    v == '11111111111' ||
    v == '22222222222' ||
    v == '33333333333' ||
    v == '44444444444' ||
    v == '55555555555' ||
    v == '66666666666' ||
    v == '77777777777' ||
    v == '88888888888' ||
    v == '99999999999'
  ) {
    return messageInvalid;
  }

  let total, index, leftover, verifyingDigit, counter;

  if (v.length >= 11) {
    /**
     * First digit verifier
     */
    index = 2;
    total = 0;
    leftover = 0;
    verifyingDigit = 0;

    for (counter = -9; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1) * index);
      index = index + 1;
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(9, 1) != '' + verifyingDigit) return messageInvalid;

    /**
     * Last digit verifier
     */
    index = 2;
    total = 0;
    leftover = 0;
    verifyingDigit = 0;

    for (counter = -10; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1) * index);
      index = index + 1;
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(10, 1) !== '' + verifyingDigit) return messageInvalid;
  }

  return true;
};

export const cnpj = v => {
  if (v === null || v === undefined || v === '') return false;

  v = v.replace(/\-/g, '').replace(/\./g, '');

  if (!/^[0-9]+$/.test(v)) return messageInvalid;

  if (
    v.length != 14 ||
    v == '11111111111111' ||
    v == '22222222222222' ||
    v == '33333333333333' ||
    v == '44444444444444' ||
    v == '55555555555555' ||
    v == '66666666666666' ||
    v == '77777777777777' ||
    v == '88888888888888' ||
    v == '99999999999999'
  ) {
    return messageInvalid;
  }

  if (v.length >= 14) {
    /**
     * First digit verifier
     */
    let total = 0,
      index = 2,
      leftover = 0,
      verifyingDigit = 0,
      counter = 0;

    for (counter = -12; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1)) * index;

      index === 9 ? (index = 2) : (index = index + 1);
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(12, 1) !== '' + verifyingDigit) return messageInvalid;

    /**
     * Last digit verifier
     */
    index = 2;
    total = 0;
    leftover = 0;
    verifyingDigit = 0;

    for (counter = -13; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1)) * index;

      index === 9 ? (index = 2) : (index = index + 1);
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(13, 1) !== '' + verifyingDigit) return messageInvalid;
  }

  return true;
};

export const validateNumberInt = v => {
  if (v.length === 0) return false;

  const regex = new RegExp('^-?[0-9]+$');

  if (!regex.test(v)) return messageInvalid;

  v = parseInt(v);

  return true;
};

export const validateNumberInt16 = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v < -32768) return 'O valor do campo é muito pequeno. Valor mínimo: -32768';

  if (v > 32767) return 'O valor do campo é muito grande. Valor máximo: 32767';

  return true;
};

export const validateNumberTinyInt = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v < 0) return 'O valor do campo deve ser positivo';

  if (v > 255) return 'O valor do campo é muito grande';

  return true;
};

export const validatePercentage = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  if (v > 100) return 'O valor do campo não poderá ser maior que 100%.';

  return true;
};

export const validatePercentageWithoutNegative = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  if (parseFloat(v.replace(c2, c1)) < 0) return 'O valor do campo não poderá ser inferior que 0%.';

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  if (v > 100) return 'O valor do campo não poderá ser maior que 100%.';

  return true;
};

export const validateIntegerPositive = v => {
  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  if (c1 == '.') {
    c2 = ',';
    v = v.replace(/[.]/g, '');
  } else {
    c2 = '.';
    v = v.replace(/[,]/g, '');
  }

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = v.replace(c2, c1);

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  if (v <= 0) return 'Digite apenas valores positivos.';

  if (v.length === 0) return true;

  const regex = new RegExp('^-?[0-9]+$');

  if (!regex.test(v)) return messageInvalid;

  return true;
};

export const validateIntegerNegative = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  if (parseFloat(v.replace(c2, c1)) < 0) return 'O valor do campo não poderá ser inferior que 0%.';

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  return true;
};

export const validateNegativeValue = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v > 1) return 'Digite apenas valores negativos.';

  return true;
};

export const validatePositiveValue = v => {
  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  if (c1 === '.') {
    c2 = ',';
    v = v.replace(/[.]/g, '');
  } else {
    c2 = '.';
    v = v.replace(/[,]/g, '');
  }

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = v.replace(c2, c1);

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  if (v <= 0) return 'Digite apenas valores positivos.';

  return true;
};

export const validatePercentageLessThan100 = v => {
  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = Math.abs(v.replace(',', '.'));

  if (v >= 100) return 'O valor do campo não poderá ser maior ou igual a 100%.';

  return true;
};

export const validateTextWithoutSpecialCharacters = v => {
  const regex = new RegExp("[!#$%¨&'()*+,-./:;?@[\\]_`{|}~]");

  if (v.match(regex)) return 'Texto contém caractere inválido.';

  return true;
};
